import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const ScrollToTop = () => {
  const { pathname } = useLocation()

  // Scroll the <main> container to the top whenever the route changes.
  // Using 'auto' (instant) rather than 'smooth' to avoid a jarring animation
  // when navigating between pages.
  useEffect(() => {
    const container = document.querySelector('main')
    if (container)
      container.scroll({
        top: 0,
        left: 0,
        behavior: 'auto',
      })
  }, [pathname])

  // On mobile, opening the virtual keyboard triggers a visualViewport resize
  // that shrinks the visible area and can cause the page to scroll unexpectedly.
  // This effect saves the scroll position when the keyboard opens (viewport
  // height drops below 75% of the window height) and restores it when the
  // keyboard closes, keeping the user's place in the form.
  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return

    let savedScrollTop = 0
    let keyboardOpen = false

    const onResize = () => {
      const main = document.querySelector('main')
      if (!main) return

      if (viewport.height < window.innerHeight * 0.75) {
        // Keyboard just opened — save current scroll position
        if (!keyboardOpen) {
          savedScrollTop = main.scrollTop
          keyboardOpen = true
        }
      } else if (keyboardOpen) {
        // Keyboard just closed — restore scroll position
        keyboardOpen = false
        main.scrollTop = savedScrollTop
        window.scrollTo(0, 0)
      }
    }

    viewport.addEventListener('resize', onResize)
    return () => viewport.removeEventListener('resize', onResize)
  }, [])

  return null
}
